SymbolWrapper